export default "__VITE_ASSET__a34c5075__"